import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { AppConfig } from '../utils/AppConfig';
import LanguageDetector from 'i18next-browser-languagedetector';

// Initialize i18n instance
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: AppConfig.defaultLocale,
    supportedLngs: AppConfig.locales,
    debug: false, //process.env.NODE_ENV === 'development',
    defaultNS: 'MGP',
    ns: ['MGP', 'Auth', 'Countries', 'Achievements'],
    resources: {},
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    returnNull: false,
  });

// Listen for language changes and update localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('locale', lng);
});

// Load all translations immediately
Promise.all(
  AppConfig.locales.map(async (locale) => {
    try {
      const messages = await import(`../locales/${locale}.json`);
      // Add all namespaces
      i18n.addResourceBundle(locale, 'MGP', messages.MGP, true, true);
      i18n.addResourceBundle(locale, 'Auth', messages.Auth, true, true);
      i18n.addResourceBundle(locale, 'Countries', messages.Countries, true, true);
      i18n.addResourceBundle(locale, 'Achievements', messages.Achievements, true, true);
    } catch (error) {
      console.error(`Failed to load locale: ${locale}`, error);
    }
  })
).then(() => {
  // Force a language change to refresh translations
  const currentLang = i18n.language;
  i18n.changeLanguage(currentLang);
});

export default i18n;
